import $ from 'jquery';

const EVENT_NAMESPACE = '.giottoContextMenu';

const onContextMenuButtonClick = (event) => {
  event.stopPropagation();

  const menu = $(event.currentTarget).find('.context-menu:first');
  const clickedAction = $(event.target).closest('.context-menu .item').length;

  if (clickedAction) {
    menu.removeClass('active');
    return;
  }

  menu.toggleClass('active');
};

const onContextMenuActionClick = (event) => {
  $(event.currentTarget).closest('.context-menu').removeClass('active');
};

export const initContextMenuListeners = () => {
  const body = $('body');

  body
    .off(`click${EVENT_NAMESPACE}`, '.option-button-container')
    .on(
      `click${EVENT_NAMESPACE}`,
      '.option-button-container',
      onContextMenuButtonClick
    );
  body
    .off(`click${EVENT_NAMESPACE}`, '.context-menu .item')
    .on(
      `click${EVENT_NAMESPACE}`,
      '.context-menu .item',
      onContextMenuActionClick
    );
};
